/* eslint-disable global-require */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import enLanding from './locales/en/landing.json';
import esLanding from './locales/es/landing.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).init({
  fallbackLng: 'es',
  lng: 'es',
  resources: {
    en: {
      translations: en,
      landing: enLanding,
    },
    es: {
      translations: es,
      landing: esLanding,
    },
  },
  ns: ['translations', 'landing'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'es'];

export default i18n;
